<template>
    <el-button :type="config.status[statusIndex]['btnType'] || 'primary'" 
    :size="config.size || 'small'"  @click="doClick">
            <i v-if="config.status[statusIndex]['icon']" class="fa" :class="config.status[statusIndex]['icon']"></i>&nbsp;
            {{config.status[statusIndex]['btnName']}}
    </el-button>
</template>
<script>
    /**
     * 按钮操作
     * @author welpher
     * @time 2021-6-22
     * @param infoData 【description: 详情页数据】
     * @param config 【description: 按钮配置】
     * {
     *      submitKey:[],
     *      api:"url",
     *      method:'', //query,create,save,delete
     *      activeKey: 'product_code' // infoData里对应的字段
     *      status:[{
     *          active:!'',
     *          btnType:'warning',// primary,success,warning,danger,info
     *          btnName:'启用',
     *          clickable:true,
     *          icon:""
     *          confirm:'是否确认解除绑定？'
     *      },
     *      {active:'',btnName:'不启用'}]
     * }
     * @param callback 【description: 完成后调用】
     */
    export default {
        name: 'LyButtonSingle',
        props: {
            infoData: {
                type: Object,
                default: () => {}
            }, 
            config: {
                type: Object,
                default: () => {}
            },
            // 完成后的回调函数
            callback: Function 
        },
        computed: {
            statusIndex () {
                let index = 0;
                if (this.config.status) {
                    let tIndex = this.config.status.findIndex((ele) => {
                        return this.infoData[this.config.activeKey] === ele.active
                    })
                    index = tIndex === -1 ? 0 : tIndex
                }
                return index;
            }
        },
        methods: {
            /**
             * 按钮点击
             */
            doClick () {
                if (this.config.status[this.statusIndex]['clickable']) {
                    let data = {}
                    this.config.submitKey.forEach(ele => {
                        data[ele] = this.infoData[ele]
                    })
                    if (this.config.status[this.statusIndex]['confirm']) {
                        this.$confirm(this.config.status[this.statusIndex]['confirm'], 
                        '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            callback: action => {
                                if (action === 'confirm') {
                                    this.$api[this.config['method']](this.config.api, data).then(() => {
                                        this.$message({
                                            type: 'success',
                                            message: '"' + this.config.status[this.statusIndex]['btnName'] + '"操作完成'
                                        })
                                        this.$emit('operDone')
                                    }).catch((msg) => {
                                        this.$message({
                                            type: 'warning',
                                            message: msg
                                        })
                                    })
                                }
                            }
                        })
                    } else {
                        this.$api[this.config['method']](this.config.api, data).then(() => {
                            this.$message({
                                type: 'success',
                                message: '"' + this.config.status[this.statusIndex]['btnName'] + '"操作完成'
                            })
                        }).catch((msg) => {
                            this.$message({
                                type: 'warning',
                                message: msg
                            })
                        })
                    }
                }
            }
        }
    }
</script>